/** حارس المسارات التي تتطلب حساباً. */

import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoadingState } from '@/components/states/States';
import { useAuth } from '@/services/auth';

export function ProtectedRoute({ children }: { children: ReactNode }): JSX.Element {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div style={{ paddingTop: 36 }}>
        <LoadingState message="نتحقق من الجلسة..." blocks={2} />
      </div>
    );
  }
  if (status === 'anonymous') {
    return <Navigate to="/auth" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
